(function($, undefined) {
	'use strict';
	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;
	let initedWithOpenSearch = false;

	var header;
	var navItems;

	var toggleMenuBtn;

	var toggleScroll = function() {
		var diff;

		if ($('body').hasClass('no-scroll')) {
			$('body').removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = win.width();
			$('body').addClass('no-scroll');
			var w2 = win.width();
			diff = w2 - w1;
		}

		changeScrollDiff(diff);
	};

	var changeScrollDiff = function(diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};

	var onClickMenuToggle = function() {
		var btn = $(this);
		if ($('body').hasClass('menu-open')) {
			closeMenu();
		} else {
			openMenu();
			var target = 0;

			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}

			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({ scrollTop: target }, 300);
				$('body').animate({ scrollTop: target }, 300);
			}
		}
	};

	var openMenu = function() {
		$('body').addClass('menu-open');
		$('.stool-shared-popup[data-id=header-mobile-panel]').addClass("visible");
		toggleScroll();
	};

	var closeMenu = function() {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			$('.stool-shared-popup[data-id=header-mobile-panel]').removeClass("visible");
			toggleScroll();
		}
	};

	var updateNavSelected = function(page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');

		navItems.each(function() {
			var t = $(this);

			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	function toggleSiteSearchOnLoad () {
		const siteSearch = $('.site-search');
		if (siteSearch.hasClass('site-search_open')) {
			siteSearch.slideDown(200);
			initedWithOpenSearch = true;
		}
	}
	
	var toggleSiteSearch = function(e) {
		e.stopPropagation();
		var siteSearch = $('.site-search');
		if (siteSearch.hasClass('site-search_open')) {
			siteSearch.removeClass('site-search_open').addClass('site-search_closed');
			siteSearch.slideUp(200);
		} else {
			siteSearch.addClass('site-search_open').removeClass('site-search_closed');
			siteSearch.slideDown(200);
		}
	};
	
	var toggleAccountDropdown = function(e) {
		e.stopPropagation();
		var accountDropdown = $('.site-header__dropdown');
		if (accountDropdown.hasClass('site-header__dropdown_open')) {
			accountDropdown.removeClass('site-header__dropdown_open').addClass('site-header__dropdown_closed');
		} else {
			accountDropdown.addClass('site-header__dropdown_open').removeClass('site-header__dropdown_closed');
		}	
	};
	var toggleAccountDropdownNotif = function(e) {
		e.stopPropagation();
		var accountDropdown = $('.site-header__dropdown-notif');
		if (accountDropdown.hasClass('site-header__dropdown_open')) {
			accountDropdown.removeClass('site-header__dropdown_open').addClass('site-header__dropdown_closed');
		} else {
			accountDropdown.addClass('site-header__dropdown_open').removeClass('site-header__dropdown_closed');
		}	
	};
	var accountDropdownClick = function(e) {
		e.stopPropagation();	
	};
	var siteSearchClick = function(e) {
		e.stopPropagation();
	};

	/* var pageEnter = function (page) {
		updateNavSelected(page);
	}; */

	var init = function() {
		winWidth = win.width();
		winHeight = win.height();
		$('body').removeClass('no-scroll');

		header = $('.site-header');
		navItems = $('.nav-item-link', header);

		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);

		if ($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}

		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		$('button.search', header).on('click', toggleSiteSearch);
		$('.site-header__dropdown-btn', header).on('click', toggleAccountDropdown);
		$('.site-header__dropdown-notif-btn', header).on('click', toggleAccountDropdownNotif);
		$('.site-header__dropdown').on('click', accountDropdownClick);
		$('.site-search').on('click', siteSearchClick);

		win.scroll(function() {});

		win.resize(function() {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
			}
		});
		
		$(document).on('click', function() {
			if ($('.site-header__dropdown').hasClass('site-header__dropdown_open')) {
				$('.site-header__dropdown').removeClass('site-header__dropdown_open').addClass('site-header__dropdown_closed');
			}
			if ($('.site-search').hasClass('site-search_open') && !initedWithOpenSearch) {
				$('.site-search').removeClass('site-search_open').addClass('site-search_closed');
				$('.site-search').slideUp(200);
			}
		});

		toggleSiteSearchOnLoad();

	};

	$(init);
})(jQuery);
